import React from "react";
import "./../styles/variable-projects.css";
import Projectsvariable from "../components/variable-projects";
import imagem1 from '../assets/images/Projetos/Provedores de Internet/antena.jpg';
import imagem2 from '../assets/images/Projetos/Provedores de Internet/provedor-img2.jpg';
import imagem3 from '../assets/images/Projetos/Provedores de Internet/provedor-img3.jpg';

const App = () => {
  const projectData = {
    date: "26/03/2018",
    title: "Provedores de Internet",
    images: [
     imagem1,
     imagem2,
     imagem3
    ],
    description:
    "Em trabalhos diretamente ligados a diversos Provedores de Internet disponibilizamos as soluções abaixo:",
    solutions: ["Link Ponto à Ponto, Antenas Microoondas"],
  };

  return <Projectsvariable {...projectData} />;
};

export default App;